






















































import { computed, defineComponent, ref } from '@vue/composition-api';

import axios from 'axios';
import { snackbar } from '@/components/GlobalSnackbar';
import UserPassword from '@/components/UserPassword.vue';
import { SERVER_URL, TEST_SERVER_URL, PROD_SERVER_URL, MPF_ABOUT_URL } from '@/environment';

export default defineComponent({
  name: 'Login',
  components: { UserPassword },
  setup(props, ctx) {
    // NOTE: May need to be computed ref
    const router = ctx.root.$router;

    const username = ref<string>('');
    const email = ref<string>('');
    const password = ref<string>('');
    const confirmPassword = ref<string>('');
    const validPassword = computed(() => password.value && password.value === confirmPassword.value);
    const formValid = computed(() => username.value && email.value && validPassword.value);
    const loginErrorMessage = ref<string>('');

    function reset() {
      username.value = '';
      email.value = '';
      password.value = '';
      confirmPassword.value = '';
      loginErrorMessage.value = '';
    }

    const updatePW = (val: string) => {
      password.value = val;
    };
    const updateCPW = (val: string) => {
      confirmPassword.value = val;
    };

    const useTestServer = ref(SERVER_URL === TEST_SERVER_URL);

    function accountCreated() {
      // Reset form
      reset();

      // Display notification
      snackbar.dispatch({
        text: 'Account created! Please login to continue',
        timeout: 3000,
        options: {
          color: 'success',
          top: true,
          immediate: true,
        },
      });

      // Endpoint doesn't return any login info, so just redirect to login page
      router.push('/login');
    }

    async function createUser() {
      if (!formValid.value) {
        return;
      }

      const serverUrl = useTestServer.value ? TEST_SERVER_URL : PROD_SERVER_URL;
      try {
        await axios.post(`${serverUrl}/auth/selfRegister`, {
          username: username.value,
          password: password.value,
          email: email.value,
        });
        accountCreated();
      } catch {
        loginErrorMessage.value = 'User with that username already exists';
      }
    }

    return {
      SERVER_URL,
      MPF_ABOUT_URL,
      createUser,
      loginErrorMessage,
      username,
      email,
      formValid,
      UserPassword,
      updatePW,
      updateCPW,
    };
  },
});
